import {useEffect} from "react";
import {type Configuration, type TypeGroups} from "../types";

export const resetValidation = (reset, configuration: Configuration) => {
  useEffect(() => {
    reset({
      ...configuration,
      ...(configuration?.typeGroupPairs ?? []).reduce<TypeGroups>(
        (typeGroups, typeGroup) => ({
          ...typeGroups,
          [`type_${typeGroup.typeId}_group_${typeGroup.groupId}`]: true
        }),
        {}
      ),
      typeGroupPairs: undefined
    });
  }, [configuration, reset]);
};
